<script lang="ts">
  import '../app.css';
  import type { LayoutData } from './$types';
  import { setLocale } from '$i18n/i18n-svelte';
  import { partytownSnippet } from '@builder.io/partytown/integration';
  import { dev } from '$app/environment';

  export let data: LayoutData;
  // at the very top, set the locale before you access the store and before the actual rendering takes place
  setLocale(data.locale);
</script>

<svelte:head>
  <script>
    partytown = {
      forward: ['dataLayer.push'],
    };
  </script>
  {#if !dev}
    <script type="text/javascript">
      (function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };
        t = l.createElement(r);
        t.async = 1;
        t.src = 'https://www.clarity.ms/tag/' + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, 'clarity', 'script', '7uw6974ijl');
    </script>
  {/if}
  <script
    type="text/partytown"
    src="https://www.googletagmanager.com/gtag/js?id=G-SMBC5QQS3Y"
  ></script>
  <script type="text/partytown">
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-SMBC5QQS3Y');
  </script>
  <script
    type="text/javascript"
    crossorigin="anonymous"
    src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9791938802380372"
  ></script>
  {@html '<script>' + partytownSnippet() + '</script>'}
</svelte:head>

<slot />
